import { Help } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSearchParams } from 'react-router-dom';
import { SHOW_HELP_PARAM } from '../HelpContent/helpParameters';

const StyledIconButton = styled(IconButton)({
  color: '#ffffff',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
});

export const HelpButton = () => {
  const [, setSearchParameters] = useSearchParams();

  const handleHelpOpen = () => {
    setSearchParameters(
      previous => {
        const newParameters = new URLSearchParams(previous);
        newParameters.set(SHOW_HELP_PARAM, '1');
        return newParameters;
      },
      { replace: true }
    );
  };

  return (
    <Tooltip title='Help'>
      <StyledIconButton onClick={handleHelpOpen}>
        <Help />
      </StyledIconButton>
    </Tooltip>
  );
};
